"use strict";

var LoggerInstance = require("js-logger").get("NavigationStore");

var AbstractStore = require("./AbstractStore");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var state = {
	isDesignMode: false
};

var NavigationStore = class extends AbstractStore {
	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}
};

NavigationStore.dispatchToken = Dispatcher.register(function (action) {
	switch (action.actionType) {
		case Constants.NAVIGATION_INITIALIZE:
			state.isDesignMode = action.isDesignMode;
			return true; // Don't emit change

		default:
			// no op
			return true;
	}

	NavigationStore.emitChange();
	return true;
});

module.exports = new NavigationStore();
